module.exports = __webpack_public_path__ + "img/en.604ace1b.png";